/* RESPONSIBLE TEAM: team-standalone */

import type { InterfaceIconName } from '@intercom/pulse/lib/interface-icons';
import type { IntegrationWarningReason } from 'embercom/components/knowledge-hub/conversational/standalone/integration-warning';
import type Platform from '../platform';
import type { StandalonePlatform } from '../../constants';

export interface ConversationExtractionRowData {
  icon: InterfaceIconName;
  title: string;
}

export interface KnowledgeHubModalData {
  integrationWarning: IntegrationWarningReason | null;
  settingsBlockedReason: string;
}

export interface ConversationExcerptData {
  title: (excerptsEnabled: boolean) => string;
  link: string | undefined;
}

export abstract class OnboardingGuideStepData {
  protected platform: Platform;

  constructor(platform: Platform) {
    this.platform = platform;
  }

  abstract titleKey(stepIdentifier: string): string;
  abstract descriptionKey(stepIdentifier: string): string;
  abstract ctaKey(stepIdentifier: string): string;
  abstract get platformName(): string;
  abstract moreInfoLinkLabel(stepIdentifier: string): string | null;
  abstract moreInfoArticleId(stepIdentifier: string): number | undefined;
  abstract shouldShowConnectDrawer(stepIdentifier: string): boolean;
}

export interface RequestAccessData {
  platformUrl: string | undefined;
  platformName: StandalonePlatform;
  imageUrl: string;
}
